import React from 'react'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { FaBan } from 'react-icons/fa'
import Device, { TestDevice } from '@context/device/model/device'
import {
  Col,
  Container,
  Row,
} from 'react-bootstrap'


interface Props {
  device: Device | TestDevice
}


const BattIcon = ({ device }: Props) => {
  const getBatteryIconClass = (batteryPct: number) => {
    let className = 'fas fa-lg fa-'
    if (batteryPct >= 90) {
      className += 'battery-full'
    } else if (batteryPct >= 75) {
      className += 'battery-three-quarters'
    } else if (batteryPct >= 50) {
      className += 'battery-half'
    } else if (batteryPct >= 25) {
      className += 'battery-quarter'
    } else {
      className += 'battery-empty'
    }
    return className
  }

  const getBatteryPercentage = (batteryLevel: number, vendor: string) => {
    let battPct = batteryLevel
    switch (vendor) {
      case 'SMARTFLOW': {
        const maxV = 7000
        const vBatt = batteryLevel > maxV ? 7000 : batteryLevel
        const maxVDelta = 2000
        const vDelta = maxVDelta - (maxV - vBatt)
        battPct = Math.round((vDelta < 0 ? 0 : vDelta / maxVDelta) * 100)
        return battPct
      }
      case 'METASPHERE': {
        const maxV = 7010
        const vBatt = batteryLevel > maxV ? 7010 : batteryLevel
        const maxVDelta = 1500
        const vDelta = maxVDelta - (maxV - vBatt)
        battPct = Math.round((vDelta / maxVDelta) * 100)
        return battPct
      }
      default:
        return battPct
    }
  }

  return (
    <Container className={'g-0'}>
      {device.batteryLevel !== null ? (
        <>
          <Row>
            <Col>
              <OverlayTrigger
                delay={{ hide: 450, show: 300 }}
                overlay={(props: any) => <Tooltip {...props}>Internal
                  Battery {getBatteryPercentage(device.batteryLevel, device.deviceVendor)}%</Tooltip>}
                placement="bottom"
              >
              <span>
                <span className={getBatteryIconClass(getBatteryPercentage(device.batteryLevel, device.deviceVendor))} />
                <span className="battery-level ml-1">{getBatteryPercentage(device.batteryLevel, device.deviceVendor)}% (I)</span>
              </span>
              </OverlayTrigger>
            </Col>
          </Row>
          {device.batteryLevelExt && (
            <Row>
              <Col>
                <OverlayTrigger
                  delay={{ hide: 450, show: 300 }}
                  overlay={(props: any) => <Tooltip {...props}>External
                    Battery {getBatteryPercentage(device.batteryLevelExt, device.deviceVendor)}%</Tooltip>}
                  placement="bottom"
                >
                    <span>
                      <span
                        className={getBatteryIconClass(getBatteryPercentage(device.batteryLevelExt, device.deviceVendor))} />
                      <span
                        className="battery-level">{getBatteryPercentage(device.batteryLevelExt, device.deviceVendor)}% (E)</span>
                    </span>
                </OverlayTrigger>
              </Col>
            </Row>
          )}
        </>
      ) : (
        <Row>
          <Col>
            <OverlayTrigger
              delay={{ hide: 450, show: 300 }}
              overlay={(props: any) => <Tooltip {...props}>Not available</Tooltip>}
              placement="bottom"
            >
              <span><FaBan /></span>
            </OverlayTrigger>
          </Col>
        </Row>
      )}
    </Container>
  )
}

export default BattIcon
